<template>
    <div>
        <div class="site" @click="showSite = !showSite">
            <div class="sitename">{{areas.length > 0 ? areas.find(item=>item.areaId==$route.params.id).areaName : ''}}
            </div>
            <div class="changesite">
                <div class="changesite_icon"></div>
                <div class="changesite_text">切换站点</div>
            </div>
        </div>
        <div class="siteList" v-if="showSite">
            <div class="siteListContainer">
                <div class="title">
                    <div class="siteTitle">站点列表</div>
                    <div class="closeSiteList" @click="showSite = false"></div>
                </div>
                <div class="search">
                    <input type="text" placeholder="请输入关键词" v-model="areaFilterText">
                    <img src="../../assets/img/search.png" alt="">
                </div>
                <div class="siteData">
                    <template v-for="(item,index) in areas">
                        <div class="siteItem" :key="index" v-if="areaFilter(item)" @click="$router.push({ path: `/Site/${item.areaId}`})">
                            <img class="siteIcon" :src="item.areaImg" alt="" />
                            <div class="siteName" :class="{ active: item.areaId == areaId }">
                                {{item.areaName}}
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        GetAreas,
    } from "@/components/Request";

    export default {
        name: "ChangeSite",
        components: {},
        props: ["areaId"],
        data() {
            return {
                showSite: false,
                areas: [],
                areaFilterText: "",
            };
        },
        beforeCreate() {
            GetAreas({
                projectId: this.$store.state.projectId
            }).then(({
                data
            }) => {
                this.areas = data.data.areas
            })
        },
        methods: {
            areaFilter(item) {
                if (!this.areaFilterText) {
                    return true
                }
                return item.areaName.indexOf(this.areaFilterText) !== -1
            },
        },
    };
</script>


<style lang="less" scoped>
    .site {
        width: 4000/192vw;
        height: 1300/108vh;
        position: fixed;
        top: 960/108vh;
        left: 400/192vw;
        background-image: url(../../assets/img/site_bg.png);
        background-size: 100% 100%;
        cursor: pointer;

        .sitename {
            font-size: 36px;
            font-family: YouSheBiaoTiHei;
            color: #e6f3fd;
            margin-top: 250/108vh;
            margin-left: 240/192vw;
        }

        .changesite {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 880/192vw;
            height: 160/108vh;
            font-size: 160/192vw;
            color: #e6f3fd;
            margin-left: 240/192vw;
        }
    }



    .changesite_icon {
        width: 160/192vw;
        height: 130/108vh;
        background-image: url(../../assets/img/change.png);
        background-size: 100% 100%;
    }

    .siteList {
        width: 4000/192vw;
        height: 5120/108vh;
        background-image: url(../../assets/img/站点列表.png);
        background-size: 100% 100%;
        position: fixed;
        top: 960/108vh;
        left: 4480/192vw;

        .siteListContainer {
            width: 90%;
            height: 90%;
            position: relative;
            top: 5%;
            left: 5%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .title {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .siteTitle {
                    font-size: 18px;
                    color: #ffffff;
                }

                .closeSiteList {
                    width: 17px;
                    height: 17px;
                    background-image: url(../../assets/img/close.png);
                    cursor: pointer;
                }
            }

            .search {
                .h(42);
                .w(362);
                margin-top: 20px;
                margin-bottom: 25px;
                overflow: hidden;
                border-radius: 20px;
                border: 1px solid rgba(255, 255, 255, 0.3);
                position: relative;

                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;

                input {
                    width: 100%;
                    height: 100%;
                    padding: 0 20px;
                    font-size: 16px;
                    outline: 0;
                    border: none;
                    background: rgba(0, 0, 0, 0.15);
                    color: #e6f3fd;
                    font-weight: 400;
                    line-height: 42px;
                }

                img {
                    margin-right: 10px;
                    cursor: pointer;
                    z-index: 99;
                }
            }

            .siteData {
                width: 100%;
                height: 80%;
                overflow-y: auto;

                .siteItem {
                    width: 100%;
                    height: 42px;
                    margin-bottom: 25px;
                    font-size: 18px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    cursor: pointer;

                    .siteName {
                        margin-left: 17px;
                        color: #fff;
                    }

                    .siteIcon {
                        width: 42px;
                        height: 39px;
                        background-size: 100% 100%;
                    }

                    .active {
                        color: rgba(13, 148, 255, 1)
                    }
                }
            }
        }
    }

    .siteData::-webkit-scrollbar {
        width: 5px;
        height: 1px;
    }

    .siteData::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    // .siteData::-webkit-scrollbar-track {
    //     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    //     border-radius: 10px;
    //     background: #111;
    // }
</style>